import { css, polished } from 'jimu-core';
export function expressionBuilderStyles(props) {
    const theme = props.theme;
    return css `
    .component-expression-builder{
      .w-33{
        width: 33% !important;
      }
      .w-85{
        width: 85%;
      }
      .fixed-at-bottom{
        width: 100%;
        height: ${polished.rem(64)};
        border-top: 1px solid ${theme.ref.palette.neutral[700]};
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: ${theme.ref.palette.neutral[400]};
      }
      .expression-builder-tab{
        padding-top: 1rem;
        padding-bottom: 1rem;
        overflow: hidden;
        width: 100%;
        height: 100%;
      }
      .common-tab{
        .option-label{
          font-size: ${polished.rem(13)};
          font-weight: 500;
          color: ${theme.ref.palette.neutral[900]};
        }
        .data-option{
          padding-left: 1rem;
          padding-right: 1rem;
        }
      }
      .field-selector-container{
        height: 100%;
      }
      .expression-editor-container{
        height: calc(100% - 90px);
      }
      .expression-editor-helper{
        height: calc(100% - 130px);
        .tab-content{
          margin: 0 -1rem;
        }
      }
      .exp-editor-helper-tab{
        height: calc(100% - 20px);
      }
      .field-selector-container, .expression-editor-container{
        width: 100%;
      }
      .expression-insert-btn{
        width: ${polished.rem(180)};
      }
      .stat-inter-btn{
        max-width: 100%;
      }
    }

  `;
}
